import { createAction } from 'redux-actions';
import Types from './types';

export const getAllUsersRequest = createAction(Types.GET_ALL_USERS_REQUEST);
export const getAllUsersFulfilled = createAction(Types.GET_ALL_USERS_FULFILLED);
export const getAllUsersRejected = createAction(Types.GET_ALL_USERS_REJECTED);

export const getUsersForRecoveryRequest = createAction(
  Types.GET_USERS_FOR_RECOVERY_REQUEST
);
export const getUsersForRecoveryFulfilled = createAction(
  Types.GET_USERS_FOR_RECOVERY_FULFILLED
);
export const getUsersForRecoveryRejected = createAction(
  Types.GET_USERS_FOR_RECOVERY_REJECTED
);

export const getRecoveriesCountFromRequestUuidRequest = createAction(
  Types.GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_REQUEST
);
export const getRecoveriesCountFromRequestUuidFulfilled = createAction(
  Types.GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_FULFILLED
);
export const getRecoveriesCountFromRequestUuidRejected = createAction(
  Types.GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_REJECTED
);

export const recoverUsersByRecoveryUuidsRequest = createAction(
  Types.RECOVER_USERS_BY_RECOVERY_UUIDS_REQUEST
);
export const recoverUsersByRecoveryUuidsFulfilled = createAction(
  Types.RECOVER_USERS_BY_RECOVERY_UUIDS_FULFILLED
);
export const recoverUsersByRecoveryUuidsRejected = createAction(
  Types.RECOVER_USERS_BY_RECOVERY_UUIDS_REJECTED
);

export const recoverUsersByRequestUuidRequest = createAction(
  Types.RECOVER_USERS_BY_REQUEST_UUID_REQUEST
);
export const recoverUsersByRequestUuidFulfilled = createAction(
  Types.RECOVER_USERS_BY_REQUEST_UUID_FULFILLED
);
export const recoverUsersByRequestUuidRejected = createAction(
  Types.RECOVER_USERS_BY_REQUEST_UUID_REJECTED
);

export const removeUsersFromClientsRequest = createAction(
  Types.REMOVE_USERS_FROM_CLIENTS_REQUEST
);
export const removeUsersFromClientsFulfilled = createAction(
  Types.REMOVE_USERS_FROM_CLIENTS_FULFILLED
);
export const removeUsersFromClientsRejected = createAction(
  Types.REMOVE_USERS_FROM_CLIENTS_REJECTED
);

export const getUsersToManageRequest = createAction(
  Types.GET_USERS_TO_MANAGE_REQUEST
);
export const getUsersToManageFulfilled = createAction(
  Types.GET_USERS_TO_MANAGE_FULFILLED
);
export const getUsersToManageRejected = createAction(
  Types.GET_USERS_TO_MANAGE_REJECTED
);

export const removeUserFromAllClientsRequest = createAction(
  Types.REMOVE_USER_FROM_ALL_CLIENTS_REQUEST
);
export const removeUserFromAllClientsFulfilled = createAction(
  Types.REMOVE_USER_FROM_ALL_CLIENTS_FULFILLED
);
export const removeUserFromAllClientsRejected = createAction(
  Types.REMOVE_USER_FROM_ALL_CLIENTS_REJECTED
);

export const removeUserPermanentlyRequest = createAction(
  Types.REMOVE_USER_PERMANENTLY_REQUEST
);
export const removeUserPermanentlyFulfilled = createAction(
  Types.REMOVE_USER_PERMANENTLY_FULFILLED
);
export const removeUserPermanentlyRejected = createAction(
  Types.REMOVE_USER_PERMANENTLY_REJECTED
);

export const removeMultipleUsersPermanentlyRequest = createAction(
  Types.REMOVE_MULTIPLE_USERS_PERMANENTLY_REQUEST
);
export const removeMultipleUsersPermanentlyFulfilled = createAction(
  Types.REMOVE_MULTIPLE_USERS_PERMANENTLY_FULFILLED
);
export const removeMultipleUsersPermanentlyRejected = createAction(
  Types.REMOVE_MULTIPLE_USERS_PERMANENTLY_REJECTED
);

export const getPartnersByUserUuidRequest = createAction(
  Types.GET_PARTNERS_BY_USER_UUID_REQUEST
);
export const getPartnersByUserUuidFulfilled = createAction(
  Types.GET_PARTNERS_BY_USER_UUID_FULFILLED
);
export const getPartnersByUserUuidRejected = createAction(
  Types.GET_PARTNERS_BY_USER_UUID_REJECTED
);
